import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type PrintProps = {
    className?: string;
};

const Print: FunctionComponent<PrintProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'print'}
            viewBox="0 0 250 250"
        >
            <path d="M63 250v-40H35.1c-3 0-12.9-.7-20.5-7.8C9.2 197 6 189.6 7 180.5v-107c0-1.3 0-13.4 8.6-21.3 4.8-4.6 11.1-6.9 19.1-6.9H49V32.6l-.2-.1c.5-7.1 6.3-9.7 9.4-10.1l4.8-.1V0h124v22.1l5.3.1h.1c3.1.4 9 3 9.6 10.1V46h10.8c.6 0 1.3-.5 1.9-.5 7.9 0 14.5 2.1 19.3 6.7 8.8 8.3 9 20.6 9 21.1v107.1c0 9.3-2.6 16.5-8.4 21.9-7.3 7-17.8 7.8-20.8 7.8H187v40H63zm114-11v-57H74v57h103zM34.4 55.2c-5 0-9 1.3-11.8 4-5.5 5.1-5.6 14-5.6 14.1v80.5c8-8.6 21.5-9.8 27.2-9.8 1.2 0 2-.1 2.3-.1h159.1c14.2 0 22.4 4.7 27.4 9.5V73.3c0-.4-.3-8.9-5.9-14.1-2.8-2.7-6.9-4-11.9-4-.6 0-1.2 0-1.8.1H36.3c-.7 0-1.3-.1-1.9-.1zM177 44V10H74v34h103z" />
        </svg>
    );
};
export default Print;
